import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseService } from "src/app/base/services/base.service";
import { Admin } from "../models/admin.model";
import { Observable } from "rxjs";

@Injectable()
export class AdminService extends BaseService<Admin> {

  constructor(public http: HttpClient) {
    super(http);
  }
  
  public deleteByType(id:number, type: string ): Observable<any> {
    return this.http.delete<any>(this.baseUrl + "/" + id + "/" + type , { headers: this.headers });
  }
  
  public getByIdAndType(id:number, type: string ): Observable<any> {
    return this.http.get<any>(this.baseUrl + "/" + id + "/" + type , { headers: this.headers });
  }

  public getPathModule(): string {
    return '/reuniao/admin';
  }
}